import React from 'react'
import classNames from 'classnames'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import UserRow from 'src/components/Elements/UserRow'

const P2PView = ({ meeting, p2pUser, currentEvent, attendee }) => {
  return (
    <div>
      <div className={classNames(generalStyles.mt05, generalStyles.mb05)}>
        <span className={fontStyles.pxsmallboldlsssin08blackgraphik12pt}>{meeting.time_block}</span>
      </div>
      {p2pUser && p2pUser?.is_attended && currentEvent.is_attended && attendee.is_attended
        ? <div className={generalStyles.mt10}>
          {p2pUser && <UserRow key={p2pUser?.user_id} user={p2pUser} />}
        </div>
        : <span className={fontStyles.pxsmalllsssin08blackgraphik12pt}>See staff at session check-in.</span>
      }
    </div>
  )
}

export default P2PView